'use strict';
angular
	.module('schoolLinqApp')
	.filter('tel2', function () {
		// handles this format: (###) ###-####
		return function (tel) {
			if (!tel) {
				return '';
			}

			var value = tel.toString().trim().replace(/^\+/, '');

			if (value.match(/[^0-9]/)) {
				return tel;
			}

			var city, number;
			city = value.slice(0, 3);
			number = value.slice(3);

			if (number) {
				if (number.length > 3) {
					number = number.slice(0, 3) + '-' + number.slice(3, 7);
				}

				return ('(' + city + ') ' + number).trim();
			} else {
				return '(' + city;
			}
		};
	})
	.filter('tel', function () {
		// handles this format: ###-###-####
		return function (tel) {
			if (!tel) {
				return '';
			}

			var value = tel.toString().trim().replace(/^\+/, '');

			if (value.match(/[^0-9]/)) {
				return tel;
			}

			var first, number;
			first = value.slice(0, 3);
			number = value.slice(3);

			if (number) {
				if (number.length > 3) {
					number = number.slice(0, 3) + '-' + number.slice(3, 7);
				}

				return (first + '-' + number).trim();
			} else {
				return first;
			}
		};
	})
	.filter('ssn', function () {
		return function (ssn) {
			if (!ssn) {
				return '';
			}

			var value = ssn.toString().trim().replace(/^\+/, '');

			if (value.match(/[^0-9]/)) {
				return ssn;
			}

			var first, number;
			first = value.slice(0, 3);
			number = value.slice(3);

			if (number) {
				if (number.length > 2) {
					number = number.slice(0, 2) + '-' + number.slice(2, 6);
				}

				return (first + '-' + number).trim();
			} else {
				return first;
			}
		};
	})
	.filter('objLength', function () {
		return function (object) {
			var count = 0;

			for (var i in object) {
				count++;
			}
			return count;
		};
	})
	.filter('zip', function () {
		return function (zip) {
			if (!zip) {
				return '';
			}

			var value = zip.toString().trim().replace(/^\+/, '');

			if (value.match(/[^0-9]/)) {
				return zip;
			}

			if (value.length > 5) {
				return (value = value.slice(0, 5) + '-' + value.slice(5, 9));
			} else {
				return value.trim();
			}
		};
	})
	.filter('startFrom', function () {
		return function (input, start) {
			if (input) {
				start = +start; // parse to int
				return input.slice(start).concat(input.slice(0, start));
			}
			return [];
		};
	})
	.filter('orderObjectBy', function () {
		return function (input, attribute) {
			if (!angular.isObject(input)) return input;

			var array = [];
			for (var objectKey in input) {
				if (Number(objectKey)) {
					array.push(input[objectKey]);
				}
			}

			array.sort(function (a, b) {
				a = parseInt(a[attribute]);
				b = parseInt(b[attribute]);
				return a - b;
			});
			return array;
		};
	})
	.filter('filterByAccountMask', function () {
		return function (input, searchValue) {
			if (!angular.isArray(input) || input.length == 0 || !input[0].AccountNumber || !searchValue) {
				return input;
			}

			let output = [];
			const maskExpr = /\?/.test(searchValue)
				? new RegExp('\\b' + searchValue.replace(/\./g, '').replace(/\_/g, '?').replace(/\?/g, '[0-9A-Za-z]'))
				: null;

			for (let item of input) {
				// If the search value isn't a mask, use the old behavior of matching within the account or description.
				let isMatch =
					maskExpr == null
						? item.AccountNumber.includes(searchValue) || item.Description.toLowerCase().includes(searchValue.toLowerCase())
						: maskExpr.test(item.AccountNumber.replace(/\./g, ''));

				if (isMatch) {
					output.push(item);
				}
			}

			return output;
		};
	})
	.filter('poStatus', function () {
		return function (input) {
			switch (input) {
				case 1:
					return 'Open';
				case 2:
					return 'Closed';
			}
		};
	})
	.filter('paymentType', function () {
		return function (input) {
			switch (input) {
				case 1:
					return 'Check';
				case 2:
					return 'Direct Deposit';
				case 3:
					return 'Check Override';
				case 4:
					return 'Pre-note';
				case 5:
					return 'EFT';
				case 6:
					return 'Cash';
			}
		};
	})
	.filter('processingType', function () {
		return function (input) {
			switch (input) {
				case 1:
					return 'Queued';
				case 2:
					return 'In Progress';
				case 3:
					return 'Saved';
				case 4:
					return 'Errors';
			}
		};
	})
	.filter('invoiceStatus', function () {
		return function (input) {
			switch (input) {
				case 1:
					return 'Unpaid';
				case 2:
					return 'Partial Paid';
				case 3:
					return 'Paid';
				case 4:
					return 'Deleted';
			}
		};
	})
	.filter('arInvoiceStatus', function () {
		return function (input) {
			switch (input) {
				case 1:
					return 'Open';
				case 2:
					return 'Partial Paid';
				case 3:
					return 'Paid';
				case 4:
					return 'Closed';
			}
		};
	})
	.filter('hcmPositionStatus', function () {
		return function (input) {
			switch (input) {
				case 1:
					return 'Vacant';
				case 2:
					return 'Partially Filled';
				case 3:
					return 'Filled';
			}
		};
	});
